var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0.43 59.54 19.39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1587_3415)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.5086 0.706543H51.7367C50.5964 0.706543 49.7192 1.07588 49.1929 2.27624L42 19.5429H47.0877C47.0877 19.5429 47.9648 17.2345 48.1403 16.6805C48.6666 16.6805 53.6665 16.6805 54.3683 16.6805C54.5437 17.3268 54.9823 19.4506 54.9823 19.4506H59.5436L55.5086 0.706543ZM49.5438 12.8024C49.9824 11.6944 51.4736 7.53933 51.4736 7.53933C51.4736 7.63167 51.9122 6.43131 52.0876 5.78497L52.4385 7.447C52.4385 7.447 53.4034 11.9714 53.5788 12.8948H49.5438V12.8024Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8066 13.3566C42.8066 17.2347 39.4733 19.82 34.2979 19.82C32.1049 19.82 29.9997 19.3584 28.8594 18.8044L29.5611 14.5569L30.1751 14.834C31.7541 15.5726 32.8067 15.8496 34.7365 15.8496C36.14 15.8496 37.6312 15.2956 37.6312 14.0029C37.6312 13.1719 37.0172 12.6179 35.0874 11.6946C33.2453 10.7712 30.7892 9.29385 30.7892 6.61613C30.7892 2.92273 34.2102 0.429688 39.0347 0.429688C40.8768 0.429688 42.4557 0.799028 43.4206 1.2607L42.7189 5.32344L42.368 4.9541C41.4908 4.58476 40.3505 4.21542 38.6838 4.21542C36.8417 4.30776 35.9646 5.13877 35.9646 5.87745C35.9646 6.70847 37.0172 7.35481 38.6838 8.18583C41.4908 9.57086 42.8066 11.1406 42.8066 13.3566Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0.891801L0.0877183 0.522461H7.63149C8.68411 0.522461 9.47357 0.891801 9.73673 2.09216L11.4034 10.4023C9.73673 5.97023 5.87712 2.36916 0 0.891801Z",
    fill: "#FAFAFA",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.017 0.706593L14.3855 19.4506H9.21013L4.82422 3.75365C7.98208 5.87735 10.6136 9.20141 11.5785 11.5098L12.1048 13.4488L16.8416 0.614258H22.017V0.706593Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.035 0.614258H28.8596L25.7894 19.4506H20.9649L24.035 0.614258Z",
    fill: "#FAFAFA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1587_3415",
    x: -26,
    y: -25.5703,
    width: 111.544,
    height: 71.3901,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 13
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1587_3415"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1587_3415",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.d126b95e3db14a97382dafb43b2b7ee8.svg";
export { ForwardRef as ReactComponent };